// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6t-0";
export var startPickingButton = "_6t-1";